<template>

    <div class="p-grid p-fluid">
        <Panel header="Selecione as etapas que farão parte do ciclo" class="p-col-12">
            <div class="p-grid p-fluid">
                <Rotulo>
                    <!-- <DataTable :value="etapaCamposTabela" :selection.sync="vinculosSelecionados"
                        v-if="this.statusTipoCiclo =='PENDENTE'">
                        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
                        <Column header="Etapa" field="code" />
                        <Column header="Descrição" field="name" bodyStyle="text-align: left" />
                    </DataTable> -->
                    <DataTable :value="etapaCamposTabela" :selection.sync="vinculosSelecionados" >
                        <Column headerStyle="width: 3em">
                            <template #body="slotProps">
                                <Checkbox :id="slotProps.data.name" :value="slotProps.data"
                                    v-model="vinculosSelecionados" :disabled="statusTipoCiclo != 'PENDENTE'" />
                            </template>
                        </Column>
                        <Column header="Etapa" field="code" />
                        <Column header="Descrição" field="name" bodyStyle="text-align: left" />
                    </DataTable>
                </Rotulo>
            </div>
        </Panel>
        <Rotulo cols="12 8" />
        <Rotulo cols="12 4">
            <Button label="Salvar" icon="pi pi-check" class="p-button-success" @click="salvaEtapa" v-if="statusTipoCiclo == 'PENDENTE'" />
        </Rotulo>
    </div>
</template>

<script>
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'
import { printToast } from '../../config/global';

export default {
    name: "etapasCiclo",
    components: { Rotulo },
    data: function () {
        return {
            vinculosSelecionados: [],
            etapaCamposTabela: [],
            vinculosAhAlterar: [],
            vinculosSalvos:[],
            resposta:[],
            statusCiclo:null,
            statusTipoCiclo:null,
            idCiclo: this.$store.state.idCiclo
        }
    },
    // computed: {
    //     ...mapState({
    //         idCiclo: state => state.idCiclo
    //     }),
    // },
    methods: {
        async carregarDados() {
            this.carregarCiclo();
            this.dados();
        
        },
        carregarCiclo() {
            this.opcoesSelecionadas();
        },
        opcoesSelecionadas() {
            this.vinculosSelecionados = this.vinculosSalvos
            // this.vinculosSelecionados = this.etapaCamposTabela
            if( this.vinculosSalvos == []){
                this.vinculosSelecionados = this.etapaCamposTabela
            }
        },
        async salvaEtapa() {
            let idenCicloEtapa = this.idCiclo
            const vinculosAhAlterar = this.vinculosSelecionados
            let jsonProps ={}
            vinculosAhAlterar.forEach(element => {
                jsonProps[String(element.code)]  = element.name
            });
            // const etapasCampos = this.etapaCamposTabela
            // let props = {}
            // etapasCampos.forEach(element2 =>{
            //     props[String(element2.code)] = element2.name
            // })
            let body ={
                idenCicloEtapa: idenCicloEtapa,
                etapasCiclo: jsonProps,
                // etapasEstaticas: props,
                // statusTipoCiclo: this.statusTipoCiclo,
                // statusCiclo: this.statusCiclo

            }
            let response = await this.$http.put(`${baseApiUrl}/gerenciaciclo/etapas`, JSON.stringify(body))
            if (response && response.status == 200) {
                this.$store.commit("setPaginaGerencia", 'gerenciaCiclo')
                printToast({ severity: 'success', summary: 'Ação Efetuada', detail: "Ciclo salvo com sucesso!", life: 3000 })
            }
        },
        dados() {
            if(this.idCiclo == null){
                this.idCiclo = null
            }else{          
            this.$http.get(`${baseApiUrl}/gerenciaciclo/${this.idCiclo}/etapas`).then(res => {
                this.etapaCamposTabela = res.data.etapasEstaticas
                this.vinculosSalvos = res.data.etapasCiclo  
                this.statusCiclo = res.data.statusCiclo
                this.statusTipoCiclo = res.data.statusTipoCiclo
                this.etapaCamposTabela = Object.keys(this.etapaCamposTabela).map(item => {''
                    return {
                        code: item,
                        name: this.etapaCamposTabela[item]
                    }
                })
                this.vinculosSalvos = Object.keys(this.vinculosSalvos).map(item => {
                    return {
                        code: item,
                        name: this.vinculosSalvos[item]
                    }
                })            
                this.opcoesSelecionadas();
            })    
        }    
        },
    },
    mounted() {
        this.carregarDados()
    }
}
</script>
<style scoped>
.botoesSuperiores {
    display: flex;
    justify-content: space-around;
}
</style>